import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcMessage16Icon, IcNextIcon, MentionIcon } from '@gem/icons';
import { Badge, IconView, IconViewSizes } from '@gem/ui-kit';

import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

import { useThreadButtonPresenter } from './ThreadButton.presenter';
import styles from './ThreadButton.styles.m.css';

type TThreadButtonTheme = '1' | '2';

interface IThreadButtonProps {
  className?: string;
  theme?: TThreadButtonTheme;
  message: ChatMessage;
}

export const ThreadButton: FC<IThreadButtonProps> = observer((props) => {
  const { message, theme = '1', className } = props;
  const presenter = useThreadButtonPresenter(message);

  if (!presenter.isVisible) {
    return null;
  }

  return (
    <div
      className={classNames(styles.container, styles[`theme-${theme}`], className)}
      role="button"
      tabIndex={0}
      onClick={presenter.onClick}
    >
      <IconView
        Icon={IcMessage16Icon}
        className={styles.icon}
        size={IconViewSizes.Small}
      />

      <span className={styles.text}>{presenter.caption}</span>

      {presenter.hasUnreadMentions && (
        <MentionIcon className={classNames(styles.icon, styles.iconMention)} />
      )}

      {presenter.hasUnread && (
        <Badge
          className={classNames(styles.icon, styles.iconUnread)}
          quantity={presenter.countUnread}
        />
      )}

      <IconView
        Icon={IcNextIcon}
        className={classNames(styles.icon, styles.iconNext)}
        size={IconViewSizes.Medium}
      />
    </div>
  );
});
